class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0, null, null, this);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class MonogramButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      const monogramDrawer = document.querySelector('monogram-drawer');
      
      monogramDrawer.open(event);
    });
  }
}

customElements.define('monogram-btn', MonogramButton);

class MonogramRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', ({ currentTarget }) => {
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.removeMonogram(currentTarget.dataset.index, parseInt(currentTarget.dataset.quantity), currentTarget.dataset.monogramVariantId, parseInt(currentTarget.dataset.monogramVariantQty), parseInt(currentTarget.dataset.monogramLineIndex), currentTarget.dataset.lineItemId);
    });
  }
}

customElements.define('monogram-remove-btn', MonogramRemoveButton);

class GiftBoxModalBtn extends HTMLElement {
  constructor() {
    super();

    this.modal = document.querySelector("[js-gift-box-modal]");

    this.init();
  }

  init() {
    this.addEventListener('click', this.open.bind(this));
  }

  open() {
    this.modal.classList.add("is-open");
  };
}

customElements.define('gift-box-modal-btn', GiftBoxModalBtn);

class GiftNoteModalBtn extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    this.addEventListener('click', this.open.bind(this));
  }

  open(evt) {
    const btn = evt.currentTarget;
    const handle = btn.getAttribute("data-product-handle");
    const id = parseInt(btn.getAttribute("data-variant-id"));
    
    const spinner = btn.querySelector(".loading__spinner");
    spinner.classList.remove("hidden");
    this.renderModal(spinner, handle, id);
  };

  renderModal(spinner, handle, id) {
    fetch(`/products/${handle}?variant=${id}&view=gift-note`)
    .then(function(response) {
      return response.text()
    }).then(function(doc) {

      const modalParent = document.createElement("gift-notes-modal");
      modalParent.setAttribute("data-target", "gift-notes-modal");

      modalParent.innerHTML = doc;
      document.body.appendChild(modalParent);
      setTimeout(() => {
        modalParent.classList.add("is-open");
      }, 100)

      spinner.classList.add("hidden");
    })
  }
}

customElements.define('gift-note-modal-btn', GiftNoteModalBtn);

class UpsellAtcBtn extends HTMLElement {
  constructor() {
    super();

    this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');

    this.init();
  }

  init() {
    this.addEventListener('click', this.triggerAddToCart.bind(this));
  }

  triggerAddToCart(event) {
    const target = event.currentTarget;
    const isCartDrawer = target.closest("#CartDrawer") ? true : false;
    const id = parseInt(target.getAttribute("data-variant-id"));
  
    const spinner = target.querySelector(".loading__spinner");
    spinner.classList.remove("hidden");
    this.cartItems.addToCart(id, 1, {}, isCartDrawer, spinner);
  }
}

customElements.define('upsell-atc-button', UpsellAtcBtn);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.cartDrawer = document.querySelector("cart-drawer");

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, event.target);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  renderAjaxCart(state, line, name, variantId) {
    const parsedState = JSON.parse(state);

    const quantityElement =
      document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
    const items = document.querySelectorAll('.cart-item');

    if (parsedState.errors) {
      quantityElement.value = quantityElement.getAttribute('value');
      this.updateLiveRegions(line, window.cartStrings.quantityError.replace('[quantity]', quantityElement.value));
      return;
    }

    this.classList.toggle('is-empty', parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector('cart-drawer');
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
    if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });
    const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;

    let message = '';
    if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
      if (typeof updatedValue === 'undefined') {
        message = window.cartStrings.error;
      } else {
        message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
      }
    }

    this.updateLiveRegions(line, message);

    const lineItem =
      document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
    if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
      cartDrawerWrapper
        ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
        : lineItem.querySelector(`[name="${name}"]`).focus();
    } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
    } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
      trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
    }

    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
  }

  updateQuantity(line, quantity, name, variantId, el) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => {
      return response.text();
    })
    .then((state) => {
      this.renderAjaxCart(state, line, name, variantId);
    })
    .catch(() => {
      this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    });
  }

  removeMonogram(line, quantity, id, monogramVariantQty, monogramVariantLine, variantId) {
    this.enableLoading(line);

    const fetchCart = async () => {
      const firstRequestBody = JSON.stringify({
        line,
        quantity,
        properties: {
          _ig: `${variantId}${id}${monogramVariantQty}`
        },
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      // const secondRequestBody = JSON.stringify({
      //   line: monogramVariantLine,
      //   quantity: 0,
      //   sections: this.getSectionsToRender().map((section) => section.section),
      //   sections_url: window.location.pathname,
      // });
      
      try {
        const firstResponse = await fetch(`${routes.cart_change_url}`,{ ...fetchConfig(), ...{ body: firstRequestBody }});
        const data = await firstResponse.text();
    
        // const secondResponse = await fetch(`${routes.cart_change_url}`,{ ...fetchConfig(), ...{ body: secondRequestBody }});
        // const secondData = await secondResponse.text();

        this.renderAjaxCart(data, line, null, variantId);
        this.disableLoading(line);
    
      } catch (error) {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      }
    }

    fetchCart();
  }

  addToCart(id, quantity, properties = {}, isCartDrawer = false, spinner) {
    const body = JSON.stringify({
      id,
      quantity,
      properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
        const giftNotesModal = document.querySelector('gift-notes-modal');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        if(giftNotesModal) {
          giftNotesModal.classList.remove("is-open");
          setTimeout(() => {
            giftNotesModal.remove();
          }, 500)
        }

        if(!isCartDrawer) {
          spinner?.classList.add("hidden");
          setTimeout(() => {
            this.cartDrawer.open();
          });
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}